import { VendorTypeEnum } from "@finway-group/shared/lib/models"
import { Form } from "antd"
import { t } from "i18next"
import React, { useEffect } from "react"
import { FilterFormProps } from "~Components/filter/filterTypes"
import { FormMinMaxDate } from "~Components/form/formMinMaxDate"
import { FormSelect } from "~Components/form/formSelect"
import { VendorSelect } from "~Components/forms/expenseForm/commonInputFields/VendorSelect"
import { useEmployees } from "~Shared/queries/employee.queries"
import { CollapseWrapper } from "~Shared/wrapper/collapse.wrapper"

export interface DeliveryNoteFilterFormValues {
    vendor?: string
    createdBy?: string
    minDateOfIssue?: string
    maxDateOfIssue?: string
}

export const DeliveryNoteFilterForm = ({ formInstance, filters, onFilter }: FilterFormProps<DeliveryNoteFilterFormValues>) => {
    const { data: employees = [] } = useEmployees({ excludeDeleted: true })

    useEffect(() => {
        formInstance.resetFields()
    }, [filters])

    return (
        <Form id="purchaseOrderFilterForm" className="form--filter" form={formInstance} onFinish={onFilter}>
            {/* Vendor  */}
            <CollapseWrapper keyCode="" header={t("deliveryNote:columns.vendor")} isCollapse isActive={!!filters.vendor}>
                <VendorSelect
                    shouldShowOnlyVerifiedVendors={false}
                    shouldRenderSelectDropdown={false}
                    selectedVendorType={VendorTypeEnum.VENDOR}
                    selectedCreditorId={filters.vendor}
                    formProps={{ name: "vendor", form: formInstance }}
                />
            </CollapseWrapper>

            {/* Date of issue  */}
            <FormMinMaxDate
                header={t("deliveryNote:columns.dateOfIssue")}
                min={{
                    name: "minDateOfIssue",
                    label: t("input:expense_filter.min_date"),
                    placeholder: t("placeholder:expense_filter.min_date"),
                    initialValue: filters.minDateOfIssue,
                }}
                max={{
                    name: "maxDateOfIssue",
                    label: t("input:expense_filter.max_date"),
                    placeholder: t("placeholder:expense_filter.max_date"),
                    initialValue: filters.maxDateOfIssue,
                }}
                formInstance={formInstance}
            />

            {/* Creator  */}
            <FormSelect
                name="createdBy"
                header={t("deliveryNote:columns.createdBy")}
                initialValue={filters.createdBy}
                options={employees}
                displayImages
                isCollapse
                showSearch
                fallback
            />

            {/* TODO [WEB-2034] add more filteres */}
        </Form>
    )
}
